<template>
    <div>
        <div class="mb-2">
            <edit-invoice-button
                v-if="$hasRole('super_admin')"
                class="mr-2"
                :invoiceId="data.id"
                type="buy"
            />

            <regenerate-invoice-button
                    v-if="$hasRole('super_admin') && !data.twinfield_booked"
                    class="mr-2"
                    :invoiceId="data.id"
                    @regenerated="refreshTable"
            />

            <book-buy-invoice-button
                    :invoiceId="data.id"
                    v-if="$hasRole('super_admin') && $can('book-invoices')"
            />
        </div>
        <div v-if="$can('send-invoice-reminders')">
            <resend-invoice-button
                    :invoiceId="data.id"
                    class="mr-2"
            />

            <create-credit-invoice-button
                    v-if="$hasRole('super_admin') && invoiceIsCreditable"
                    :invoiceId="data.id"
                    type="buy"
            />
        </div>
    </div>
</template>

<script>
    import { DestroyAlert, SuccessAlert } from '~/Swals'
    import {
        CreateCreditInvoiceButton,
        ResendInvoiceButton,
        RegenerateInvoiceButton,
        BookBuyInvoiceButton,
        EditInvoiceButton,
    } from '~/components/buttons'

    export default {
        name: 'actions',

        props: ['data', 'index'],

        components: {
            CreateCreditInvoiceButton,
            ResendInvoiceButton,
            RegenerateInvoiceButton,
            BookBuyInvoiceButton,
            EditInvoiceButton,
        },

        data() {
            return {
                invoiceType: 'buy',
            }
        },

        computed: {
            invoiceIsCreditable() {
                return config.invoices.creditable_statusses.includes(this.data.status) && !this.data.credit_for
            }
        },

        methods: {
            refreshTable() {
                setTimeout(() => {
                    vue.$emit('reloadTable');
                }, 3000)
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
